import { combineReducers } from 'redux';
import { CoreModuleState } from '../types';
import { itemReducer } from '../../setup/reducers/item.reducer.';
import { classifierTypesReducer } from './classifiertypes.reducer';
import { ratePlanPeriodReducer } from './rateplanperiod.reducer';
import { brokerRateReducer } from '../../setup/reducers/brokerrate.reducer';
import { carClassReducer } from './carClass.reducer';

export const coreReducer = combineReducers<CoreModuleState>({
  items: itemReducer,
  brokerRates: brokerRateReducer,
  classifierTypes: classifierTypesReducer,
  ratePlanPeriods: ratePlanPeriodReducer,
  carClasses: carClassReducer
});
